import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
export class FollowUpService {
   async getFollowUpData(query?: LocationQuery) {
      const response = await http.get('/follow-up', { params: query });
      return response.data;
   }
}
